// Things that sit inside a Polaris bubble — an attachment, a file, a voice
// note — follow the bubble, not the theme. The same message can be on the
// grey customer bubble, the carbon agent bubble or, in dark mode, the paper
// one: anything painted with a theme color (white chip, slate text) vanishes on
// one of them. So every surface, border and control here is a tint of the
// bubble's own text color, `currentColor`. Written out in full because
// Tailwind only sees literal class names.
export const ON_BUBBLE = {
  surface: 'bg-[color:color-mix(in_oklch,currentColor_10%,transparent)]',
  border:
    'border-solid border-[color:color-mix(in_oklch,currentColor_20%,transparent)]',
  muted: 'opacity-80',
  quiet: 'opacity-80 hover:opacity-100',
  track: 'bg-[color:color-mix(in_oklch,currentColor_30%,transparent)]',
  // The kit's outline Button, re-tinted: in dark mode its dark fill and light
  // text vanish on the paper agent bubble.
  action:
    'w-full shadow-none bg-transparent dark:bg-transparent text-current hover:text-current border-[color:color-mix(in_oklch,currentColor_35%,transparent)] dark:border-[color:color-mix(in_oklch,currentColor_35%,transparent)] hover:bg-[color:color-mix(in_oklch,currentColor_10%,transparent)] dark:hover:bg-[color:color-mix(in_oklch,currentColor_10%,transparent)]',
};
